import { Component } from '@angular/core';
import { VERSION } from '@env';

@Component({
  selector: 'modal-acerca-de',
  templateUrl: 'modal-acerca-de.html'
})
export class ModalAcercaDeComponent {

  version = VERSION;
  show: boolean;

  constructor() {
  
  }

  present() {
    this.show = true;
  }

  close() {
    this.show = false;
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-acerca-de/modal-acerca-de.ts